// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2pOw3","box":"WorkspacesBox_box__1AdBn","node":"WorkspacesBox_node__3mK8I"};